import { defaultFormState } from '@/presentation/components/models';
import { atom } from 'recoil';
export const addStudentsManuallyAtom = atom({
    key: 'addStudentsManuallyAtom',
    default: {
        isLoading: false,
        classData: null,
        modalAddStudent: false,
        mainModal: false,
        studentsForSave: [],
        studentForRemove: null,
        studentForEdit: null
    }
});
export const addStudentFormAtom = atom({
    key: 'addStudentFormAtom',
    default: Object.assign(Object.assign({}, defaultFormState), { firstName: '', lastName: '', email: '', idClassSelected: null, firstNameError: '', lastNameError: '', emailError: '', idClassSelectedError: '' })
});
